/* TODO:
    Look into replacing with lodash's `truncate`.
    (Behavior of this function is different from truncate as it is inclusive of the last word
    that reaches the string length limit.)
 */
const shortenText = (text, length) => {
  text = typeof text === 'string' ? text : '';
  while (length < text.length && /[a-zA-Z]/.test(text[length])) {
    length += 1;
  }

  return `${text.slice(0, length)}${text.length > length ? '…' : ''}`;
};

export default shortenText;
